import { Box, Drawer, List, Link, styled } from "@mui/material";
import { MenuItem, RuleFactoryType } from "@repo/server-api/types";
import { useUserRoles, RuleComponent } from "@repo/shared/components";
import { useTranslation } from "next-i18next";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { gnag_logo as logo } from "@repo/legacy/img/index";

import SidebarItem from "./SidebarItem";

// Styled Component für Drawer
const StyledDrawer = styled(Drawer)(({ theme }) => ({
	"& .MuiDrawer-paper": {
		width: theme.sidebar.width,
		boxSizing: "border-box",
		backgroundColor: theme.palette.primary.main,
		boxShadow: theme.shadows[4],
	},
}));

interface SideBarProps {
	variant: "permanent" | "temporary";
	open?: boolean;
	onClose?: () => void;
	menuData: MenuItem[];
	ruleFactory: RuleFactoryType;
}

const Sidebar: React.FC<SideBarProps> = ({ variant, open, onClose, menuData, ruleFactory }) => {
	const { t } = useTranslation();

	const roles = useUserRoles();

	return (
		<StyledDrawer
			variant={variant}
			open={open}
			onClose={onClose}
			className="menu">
			<Box
				sx={{
					height: "100%",
					overflow: "hidden",
					mb: 12,
					width: "100%",
				}}>
				<Link component={RouterLink} to="/" className="hand">
					<img src={logo} alt="logo" className="logo margin0Auto desktop" />
				</Link>
				<Box sx={{ height: "95%", overflow: "auto" }}>
					<List>
						{menuData.map((item) => (
							<RuleComponent
								rule={() => ruleFactory.allowedMenuItem(item.key, roles.roles)}
								key={item.label}>
								<SidebarItem key={item.label} item={item} ruleFactory={ruleFactory} />
							</RuleComponent>
						))}
					</List>
				</Box>
			</Box>
			<Box
				sx={{
					position: "fixed",
					ml: 1,
					bottom: 0,
					height: "30px",
					width: "100%",
				}}>
				{t("version")}: {import.meta.env.VITE_APP_VERSION}
			</Box>
		</StyledDrawer>
	);
};

export default Sidebar;

// TODO See how to remove this part and put only vite-env.d.ts
declare global {
	interface ImportMetaEnv {
		readonly VITE_API_HOST: string;
		readonly VITE_KEYCLOAK_URL: string;
		readonly VITE_KEYCLOAK_REALM: string;
		readonly VITE_KEYCLOAK_CLIENT_ID: string;
		readonly VITE_APP_VERSION: string;
	}

	interface ImportMeta {
		readonly env: ImportMetaEnv;
	}
}
